<template>
    <div class="recompensas-card" v-if="storeVersioned">
        <a class="recompensas-card__img" :href="itemUrl">
            <img v-if="item.promotion_image" width="400" height="300"
                 :src="item.promotion_image.public_path + '?size=list'"
                 class="recompensas-card__img-in"
                 :alt="item.promotion_image.alt"/>
        </a>

        <div class="recompensas-card__right">
            <div class="d-flex flex-column h-100 justify-content-center align-items-center px-3">
                <div class="recompensas-card__brand mt-3 mt-sm-2">
                    <img v-if="storeVersioned && storeVersioned.thumbnail" width="150" height="150"
                         :src="storeVersioned.thumbnail.public_path + '?size=list'"
                         class="img-brand"
                         :alt="storeVersioned.thumbnail.alt"/>
                </div>
                <span class="recompensas-card__discount mt-1 mb-2">
                    {{item.discount}}
                </span>
            </div>
            <a class="btn btn-primary px-4 w-100 d-flex flex-nowrap align-items-center justify-content-center" :href="itemUrl">
                <span class="pe-3" v-html="configTexts.detailedBtn"></span>
                <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" alt="arrow" class="arrow-icon" width="18" height="18">
            </a>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        item: Object,
        locale: String,
        configTexts: Object,
        contentVersionID: [String, Number]
    },
    computed: {
        store() {
            return this.item.relationships?.story?.store ? this.item.relationships.story.store[0] : null;
        },
        itemUrl() {
            if (this.storeVersioned === null || this.item === null) return;

            return this.locale === 'es' ?
                `/${this.locale}/tiendas/${this.storeVersioned.slug}/promocion/${this.item.slug}` :
                `/${this.locale}/stores/${this.storeVersioned.slug}/promotion/${this.item.slug}`
        },
        storeVersioned() {
              return this.store?.versions ? this.store.versions.filter(x => parseInt(x.content_version_id) === parseInt(this.contentVersionID))[0] : null
        }
    }
}
</script>

<style>
.img-no-fluid{
    max-width: initial !important;
    height: auto !important;
    width: auto !important;
}
.img-brand{
    height: 100%;
    object-fit: contain;
}
.recompensas-card__img-in{
    width: 100%;
    height: 100%;
    object-position: left;
}
</style>